import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: 73,
      padding: theme.spacing(1.5, 7),
      marginTop: theme.spacing(3),
      borderRadius: theme.shape.borderRadiusMedium,
      backgroundColor: COLORS.gray.gray90,
    },
    skeletonRect: {
      height: 25,
    },
  }),
  {
    name: 'CsvUploadSkeleton',
  }
);
